import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterModule } from "@angular/router";
//import { CommonModule } from '@angular/common';
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from "./admin-layout.routing";
import { UserProfileComponent } from "../../user-profile/user-profile.component";
import { TableListComponent } from "../../table-list/table-list.component";
import { IconsComponent } from "../../icons/icons.component";
import { ApoinmentComponent } from "../../Apoinment/Apoinment.component";
import { TableListModule } from "../../table-list/table-list.module";
import { AdminLayoutComponent } from "./admin-layout.component";
import { ComponentsModule } from "../../components/components.module";
//import { MaterialModule} from '../../material.module'
import { MatExpansionModule } from "@angular/material/expansion";
import { DashboardModule } from "app/dashboard/dashboard.module";
import { OpdVisitModule } from "app/opdvisits/opdvisits.module";

import { AppointmentModule } from "app/upgrade/appointment.module";
import { EmrModule } from "app/EMR/emr.module";
import { SharedModule } from "app/shared/shared.module";
//import { NgxQRCodeModule } from 'ngx-qrcode2';
import { ExportService } from "app/reports/services/export.service";
import { MastersModule } from "app/masters/masters.module";

import { DoctorDashboardModule } from "app/Doctor-Dashboard/doctor-dashboard.module";
import { ReportsModule } from "app/reports/reports.module";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
//import { NgxBarcodeModule } from 'ngx-barcode';
import { Ng2TelInputModule } from "ng2-tel-input";
import { AddServiceComponent } from "app/billing/add-service/add-service.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DentalEmrModule } from "app/Dental-Emr/Dental-Emr.module";
import { MatStepperModule} from '@angular/material/stepper';
import { SqlChatbotComponent } from "app/sql-chatbot/sql-chatbot.component";
import { SqlResultChartComponent } from "app/sql-chatbot/sql-result-chart.component";
import { ChartsModule } from "ng2-charts";

@NgModule({
  imports: [
    EmrModule,
    MastersModule,
    AppointmentModule,
    OpdVisitModule,
    DashboardModule,
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    SharedModule,
    //ReactiveFormsModule,
    MatExpansionModule,
    TableListModule,
    ComponentsModule,
    // MaterialModule,
    //NgxQRCodeModule,
    MastersModule,
    DoctorDashboardModule,
    ReportsModule,
    BsDropdownModule.forRoot(),
    //NgxBarcodeModule,
    Ng2TelInputModule,
    DentalEmrModule,
    MatStepperModule,
    ChartsModule
  ],
  declarations: [
    UserProfileComponent,
    TableListComponent,
    // TypographyComponent,
    IconsComponent,
    // MapsComponent,
    // NotificationsComponent,
    // UpgradeComponent,
    ApoinmentComponent,
    AdminLayoutComponent,
    AddServiceComponent,
    SqlChatbotComponent,
    SqlResultChartComponent,
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, // Tells Angular we will have custom tags in our templates
  ],
  providers: [ExportService],
})
export class AdminLayoutModule {}
